/**
 * This is a file to perform common utility for OLAP and Relational datasource
 *
 * @hidden
 */
export class PivotExportUtil {
    static getClonedPivotValues(pivotValues) {
        const clonedSets = [];
        for (let i = 0; i < pivotValues.length; i++) {
            if (pivotValues[i]) {
                clonedSets[i] = [];
                for (let j = 0; j < pivotValues[i].length; j++) {
                    if (pivotValues[i][j]) {
                        clonedSets[i][j] =
                            this.getClonedPivotValueObj(pivotValues[i][j]);
                    }
                }
            }
        }
        return clonedSets;
    }
    static getClonedPivotValueObj(data) {
        let keyPos = 0;
        let framedSet = {};
        if (!(data === null || data === undefined)) {
            const fields = Object.keys(data);
            while (keyPos < fields.length) {
                framedSet[fields[keyPos]] = data[fields[keyPos]];
                keyPos++;
            }
        }
        else {
            framedSet = data;
        }
        return framedSet;
    }
    static isContainCommonElements(collection1, collection2) {
        for (let i = 0, cnt = collection1.length; i < cnt; i++) {
            for (let j = 0, lnt = collection2.length; j < lnt; j++) {
                if (collection2[j] === collection1[i]) {
                    return true;
                }
            }
        }
        return false;
    }
}
